import { Injectable } from '@angular/core';
import { FlyToOptions } from '@trimblemaps/trimblemaps-js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NextPrevService {
  private backBtnchange = new BehaviorSubject<FlyToOptions>(null);
  readonly backBtnchange$ = this.backBtnchange.asObservable();

  private forwardBtnchange = new BehaviorSubject<FlyToOptions>(null);
  readonly forwardBtnchange$ = this.forwardBtnchange.asObservable();

  private prevStack: FlyToOptions[] = [];
  private nextStack: FlyToOptions[] = [];

  get prevStackValue(): FlyToOptions[] {
    return this.prevStack;
  }
  get nextStackValue(): FlyToOptions[] {
    return this.nextStack;
  }
  updateForwardBtn(state) {
    this.forwardBtnchange.next(state);
  }
  updateBackBtn(state) {
    this.backBtnchange.next(state);
  }
  popPrevStack() {
    this.prevStack.pop();
  }
  addInPrevStack(state) {
    this.prevStack.unshift(state);
  }
  addInNextStack(state) {
    this.nextStack.unshift(state);
  }
  shiftprevStack(): FlyToOptions {
    return this.prevStack.shift();
  }
  shiftnextStack(): FlyToOptions {
    return this.nextStack.shift();
  }
  clearNextStack() {
    this.nextStack = [];
  }
  clearPrevStack() {
    this.prevStack = [];
  }
}
